import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAppState } from "@/store/useApp";
import { ListFilter } from "lucide-react";

interface DocumentCourseFilterProps {
  selectedCourseIds: string[];
  onCourseFilterChange: (courseIds: string[]) => void;
}

export const DocumentCourseFilter = ({
  selectedCourseIds,
  onCourseFilterChange,
}: DocumentCourseFilterProps) => {
  const courses = useAppState((state) => state.courses || []);

  const handleCourseToggle = (courseId: string) => {
    const newSelection = selectedCourseIds.includes(courseId)
      ? selectedCourseIds.filter((id) => id !== courseId)
      : [...selectedCourseIds, courseId];

    onCourseFilterChange(newSelection);
  };

  const hasFilters = selectedCourseIds.length > 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={`ml-1 h-6 w-6 ${
            hasFilters ? " text-brand" : ""
          }`}
        >
          <ListFilter className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-80" align="start">
        <DropdownMenuLabel>Filter by course</DropdownMenuLabel>
        <DropdownMenuSeparator />

        {courses.length === 0 ? (
          <div className="px-2 py-1.5 text-sm text-muted-foreground">
            No courses available
          </div>
        ) : (
          courses.map((course) => {
            const isSelected = selectedCourseIds.includes(course.id);

            return (
              <DropdownMenuCheckboxItem
                key={course.id}
                checked={isSelected}
                onCheckedChange={() => handleCourseToggle(course.id)}
                className="flex items-center space-x-2"
              >
                <div className="flex items-center space-x-2 flex-1">
                  <div className="flex flex-col">
                    <span className="font-medium">{course.reference}</span>
                    {course.title && (
                      <span className="text-xs text-muted-foreground">
                        {course.title}
                      </span>
                    )}
                  </div>
                </div>
              </DropdownMenuCheckboxItem>
            );
          })
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
